<template>
  <div id="app" style="display: flex; flex-direction: column; height: 100%;">
    <router-view v-slot="{ Component }" class="router-view">
      <!-- since StudentInfo has parameter, so it should not be cached -->
      <keep-alive :exclude="['BackendLogin', 'BackendLogout', 'SignupView', 'MyCourse', 'MyAttendance', 'StudentInfo', 'ParentInfo', 'CoursePhoto']">
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <nav v-if="userStore.isAuthenticated" class="nav">
      <el-menu mode="horizontal" :router="true" class="el-menu" :default-active="this.$route.path" :ellipsis="false">
        <!-- <el-menu-item index="/data-fetcher" class="nav-item">
          <span>Data Fetcher</span>
        </el-menu-item> -->
        <el-menu-item index="/course-list" class="nav-item">
          <span>{{ $t('Courses') }}</span>
        </el-menu-item>
        <el-menu-item index="/home" class="nav-item">
          <span>{{ $t('Home') }}</span>
        </el-menu-item>
        <!-- <el-menu-item index="/backend-logout" class="nav-item">
          <span>Logout</span>
        </el-menu-item> -->
      </el-menu>
    </nav>
  </div>
</template>

<script>
import { Notebook, Document, Calendar, HomeFilled, Close, Setting, User, Lock, Menu, Key, OfficeBuilding, House } from '@element-plus/icons-vue'
import { useUserStore } from './stores/Global'; 
import { AUTHORITIES } from './constants/authorities';

export default {
  components: {
    Notebook,
    Document,
    Calendar,
    HomeFilled,
    Close,
    Setting,
    User,
    Lock,
    Menu,
    Key,
    OfficeBuilding,
    House
  },
  data() {
    return {
      AUTHORITIES,
      cachedComponents: {},
      routeTitles: {
        '/class': 'Class',
        '/my': 'My',
        '/backend-logout': 'Logout'
      }
    };
  },
  setup() {
    const userStore = useUserStore();
    
    return {
      userStore
    };
  },
  computed: {
    // Get user authorities from your store
    userAuthorities() {
      return this.userStore.authorities || [];
    }
  },
  methods: {
    // Check if user has a specific authority
    hasAuthority(requiredAuthority) {
      // If no authorities are required, allow access
      if (!requiredAuthority) return true;
      
      // Check if user has the required authority
      return this.userAuthorities.includes(requiredAuthority);
    },
    
  },
  watch: {
  },
  mounted() {
  },  
};
</script>

<style>
/* You can put this in your App.vue or a global CSS file */
.router-link {
  margin-right: 10px;
  text-decoration: none;
  color: #000;
  font-size: 1.2rem;
  font-weight: bold;
}

.router-view {
  height: 92dvh;
  /* margin: 8px; */
  /* overflow: hidden; */
}

.button {
  display: inline-block;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  text-align: center;
  text-decoration: none;
  border-radius: 5px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  margin-right: 10px;
  transition: background-color 0.3s;
}

.button:hover {
  background-color: #0056b3;
}

/* Tab styles */
.tabs-container {
  padding: 0 10px;
  background-color: #f5f7fa;
  /* border-bottom: 1px solid #e4e7ed; */
}

.el-menu {
  border-bottom: 0px solid #e4e7ed !important;
}

.el-tabs__item {
  height: 32px;
  line-height: 32px;
}

.el-tabs__item.is-active {
  font-weight: bold;
}

.tab-content {
  height: 100%;
  width: 100%;
  position: relative;
}

/* Hide app header in iframe mode */
body.iframe-mode .nav,
body.iframe-mode .tabs-container {
  display: none !important;
}

body.iframe-mode #app {
  padding-top: 0 !important;
}

.nav {
  border-top: 1px solid green

}

.nav-item {
  border-right: 1px solid #e4e7ed;
}

body {
  font-family: "Noto Sans", "PingFang SC", "Microsoft YaHei", sans-serif;
  /* font-family: "Microsoft YaHei", "Noto Sans", "PingFang SC", sans-serif; */
}

</style>
